import { initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { app } from './config';

const isLocal = import.meta.env.VITE_STAGING === 'local';
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: isLocal,
});
if (isLocal) connectFirestoreEmulator(db, '127.0.0.1', 8080);
